import { put, takeLatest, call } from 'redux-saga/effects';

import Theme, { ThemesPage } from '@interfaces/themes';
import { redirectToNotFound } from 'client/helpers/redirectTo';

import * as actions from './actions';
import * as types from './types';
import * as service from './service';

function* fetchThemes() {
    try {
        const data: ThemesPage = yield call(service.fetchThemes);

        yield put(actions.fetchThemesSuccess(data));
    } catch (error) {
        yield put(actions.fetchThemesError(error.message));
    }
}

function* fetchTheme(action: any) {
    try {
        const { slug } = action.payload;
        const data: Theme = yield call(service.fetchTheme, slug);

        yield put(actions.fetchThemeSuccess(data));
    } catch (error) {
        yield put(actions.fetchThemeError(error.message));
        yield put(redirectToNotFound());
    }
}

export default function* themesSaga() {
    yield takeLatest(types.FETCH_THEMES, fetchThemes);
    yield takeLatest(types.FETCH_THEME, fetchTheme);
}
